import { FC } from 'react';

const Loading: FC = () => {
    return <>'Laden...'</>;
};

export default Loading;
